import { inject, Injectable } from '@angular/core';
import { NativeRegionNameService } from '@knorr-bremse-portals/ngx-components/services/native-region-name';
import { REGION_NAMES } from './intl/region-names.intl';

@Injectable({
  providedIn: 'root',
})
export class CountryNameService {

  private nativeRegionNameService = inject(NativeRegionNameService);

  public getName(countryCode: string): string {
    return REGION_NAMES[countryCode] ?? this.nativeRegionNameService.getNativeName(countryCode);
  }
  public getCombinedName(countryCode: string): string {
    const name = this.getName(countryCode) ?? countryCode;
    const nativeName = this.nativeRegionNameService.getNativeNames()[countryCode]
    if (name === nativeName) {
      return name;
    } else {
      return `${nativeName} - ${name}`;
    }
  }

  public getCountryCodeFromLanguageCode(languageCode: string): string {
    if (languageCode === 'ja') {
      return 'jp';
    } else if (languageCode === 'sv') {
      return 'se';
    } else if (languageCode === 'zh') {
      return 'cn';
    } else if (languageCode === 'pt') {
      return 'br';
    } else if (languageCode === 'ko') {
      return 'kr';
    } else if (languageCode === 'da') {
      return 'dk';
    } else if (languageCode === 'kk') {
      return 'kz';
    }
    return languageCode;
  }

}
